import { gql, useQuery } from '@apollo/client';
import { UserTopicApplicationsQuestionnaires } from '@dieterApi/user/useUserQuery';

export const FILE_FIELDS = gql`
  fragment UserFileFields on File {
    id
    name
    size
    uri
    url
  }
`;

export const TOPIC_FIELDS = gql`
  ${FILE_FIELDS}
  fragment UserTopicFields on Topic {
    id
    title
    titleLocales {
      de
      en
    }
    order
    helpText
    subItemLocales {
      id
      title
    }
    enabled
    tags {
      tag
    }
    files {
      ...UserFileFields
    }
    hasFiles
    shouldHaveFiles
    status
  }
`;

export const QUESTIONNAIRE_FIELDS = gql`
  fragment UserQuestionnaireFields on LocalQuestionnaire {
    id
    questionnaireId
    companyId
    createdAt
    updatedAt
    sectionModifiedAt
    state
    isBroken
    sectionStates
    progress
    sectionProgress
    accessToken
    userValueIndex
    documentConfirmations {
      name
      employeeId
      createdAt
      documentNumber
      isStale
      staleReason
    }
    applicationVersion {
      version
      versionDate
    }
  }
`;

export const APPLICATION_FIELDS = gql`
  fragment UserAppFields on Application {
    id
    title
    order
    sectionLabels
    documentLabels
    versions {
      version
      versionDate
    }
    splitApplication
    splitDocument
    status
    type
    class
    tags {
      tag
    }
  }
`;

export const GET_TOPICS = gql`
  ${TOPIC_FIELDS}
  ${APPLICATION_FIELDS}
  ${QUESTIONNAIRE_FIELDS}

  query GetTopics($companyId: String!, $topicIds: [String!]) {
    getTopics(companyId: $companyId, topicIds: $topicIds) {
      ...UserTopicFields
      applications {
        ...UserAppFields
        questionnaires {
          ...UserQuestionnaireFields
        }
      }
    }
  }
`;

export interface GetTopicsResult {
  getTopics: UserTopicApplicationsQuestionnaires[];
}

export interface GetTopicsVariables {
  companyId: string;
  topicIds?: string[];
}

export function useTopicsQuery(companyId: string, topicIds?: string[]) {
  return useQuery<GetTopicsResult, GetTopicsVariables>(GET_TOPICS, {
    variables: { companyId, topicIds },
    skip: !companyId,
  });
}
